import { defineMessages } from "react-intl";

const DATA_REPORT_LIST = "data-report-list";

const dataReportsMessages = defineMessages({
  personalDataReportProcessing: {
    id: `${DATA_REPORT_LIST}.personal-data-report-processing`,
    defaultMessage: `<date></date>: Personal data report processing`,
    description:
      "Text explaining to user that this data report is still processing."
  },
  viewPersonalDataReport: {
    id: `${DATA_REPORT_LIST}.view-personal-data-report`,
    defaultMessage: `<date></date>: <a>View personal data report</a>`,
    description: "Link text for a user to go view this data report."
  },
  unableToLoadReports: {
    id: `${DATA_REPORT_LIST}.unable-to-load-reports`,
    defaultMessage: "Unable to load reports. Please try refreshing the page.",
    description: "Error text for when the request to get data reports fails "
  },
  noCurrentReports: {
    id: `${DATA_REPORT_LIST}.no-current-reports`,
    defaultMessage: "There are no current reports",
    description: "Text for when there are no reports"
  }
});

export default dataReportsMessages;
